import { FC, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import styles from "./main-wrapper.module.scss";

export interface MainWrapperProps {
  fill?: boolean;
}

export const MainWrapper: FC<MainWrapperProps> = ({ children, fill }) => {
  const [visible, setVisible] = useState(true);
  const ref = useRef<HTMLDivElement>(null);

  const location = useLocation();

  function onScroll() {
    const element = ref.current;

    if (!element) return;

    setVisible(element.scrollTop < 150);
  }

  useEffect(() => {
    if (ref.current) {
      ref.current?.scrollTo({
        top: 0,
      });

      setTimeout(() => {
        onScroll();
      }, 0);

      function onScrollHandler() {
        onScroll();
      }

      const currentRef = ref.current;
      currentRef.addEventListener("scroll", onScrollHandler);

      return () => {
        currentRef.removeEventListener("scroll", onScrollHandler);
      };
    }

    return undefined;
  }, [location.key]);

  return (
    <main ref={ref} className={styles.main} data-scrolled-down={!visible}>
      <div className={fill ? styles.mainFilled : styles.mainCentered}>
        {children}
      </div>
    </main>
  );
};
